import styled from 'styled-components'
import { styles } from 'lib/ui/components/Form/components/Input'

export const StyledTextarea = styled.textarea`
  ${styles}
  height: 10em;
`
